import { Button } from "@/components/ui/button";

export function QuickExtendButton({
  minutes,
  disabled,
  onClick,
}: {
  minutes: number;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <Button
      variant="outline"
      className="flex h-12 flex-col self-start px-3 py-4 text-center"
      disabled={disabled}
      onClick={onClick}
    >
      <span className="text-md font-bold">{minutes}</span>
      <span className="text-xs">Mins</span>
    </Button>
  );
}
